import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import { GetBrandBuildSettings } from '../quoteToolConfigs/buildSettings';

export const BrandMetaTags = (
  {
    brand: {
      key: brandKey,
      title: brandTitle,
      homeUrl,
      favIconUrl,
      appIconUrl
    },
    seo: {
      title,
      description
    },
    site = 'public'
  }
) => {
  const isLocal = process.env.REACT_APP_ENV === 'local';
  const {
    libraryVersion,
    cdnPath,
    cssFilePath
  } = GetBrandBuildSettings({ brand:brandKey, site, buildDirectory: '' });

  return (
    <>
      <Helmet>
        <title>{ title }</title>

        <base href="/"/>

        <meta charSet="utf-8"/>
        <meta httpEquiv="Content-Type" content="text/html; charset=utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge" />

        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="robots" content="noindex, follow" />

        <meta name="description" content={ description } />
        <meta property="og:description" content={ description } />
        <meta property="og:locale" content="en_US" />
        <meta property="og:title" content={ title } />
        <meta property="og:url" content={ homeUrl } />
        <meta property="og:site_name" content={ brandTitle } />

        <meta property="twitter:url" content={ homeUrl } />
        <meta property="twitter:title" content={ title } />
        <meta property="twitter:description" content={ description } />

        <link rel="icon" href={ favIconUrl } />
        <link rel="shortcut icon" type="image/ico" href={ favIconUrl } />
        <link rel="apple-touch-icon" href={ appIconUrl || favIconUrl } />

        <link rel="canonical" href={ homeUrl } />
      </Helmet>

      {
        isLocal &&
        <Helmet>
          <link rel="preconnect" href={ cdnPath } crossOrigin/>
          <link rel="preload" as="style"
            href={ `${ cssFilePath }/petsure.${ libraryVersion }.css` }/>
          <link rel="preload" as="style"
            href={ `${ cssFilePath }/${ brandKey }.${ libraryVersion }.css` }/>

          <link rel="stylesheet" type="text/css"
            href={ `${ cssFilePath }/petsure.${ libraryVersion }.css` }/>
          <link rel="stylesheet" type="text/css"
            href={ `${ cssFilePath }/${ brandKey }.${ libraryVersion }.css` }/>
        </Helmet>

      }
    </>
  );
};

// TODO: Pull the brand propTypes from the PetSureBrandPartnerConfigs package

BrandMetaTags.propTypes = {
  brand: PropTypes.shape({
    key: PropTypes.string,
    title: PropTypes.string,
    homeUrl: PropTypes.string,
    favIconUrl: PropTypes.string,
    appIconUrl: PropTypes.string
  }).isRequired,
  seo: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string
  }).isRequired,
  site: PropTypes.string
};